import {loadXLSX} from 'yougile-util'
import {State} from '../types'
import {getColumns} from './get-columns'
import {validateColumns} from './validate-columns'

export const onLoadFile =
  (state: State, file: File) => (e: ProgressEvent<FileReader>) => {
    const data = e.target?.result
    if (!data) {
      state.errors = ['Failed to read file']
      return
    }
    try {
      loadXLSX(xlsx => {
        state.workBook = xlsx.read(data, {type: 'string', raw: true})
        state.selectedFile = file
        state.loading = false
        if (state.workBook) {
          state.columnTitles = getColumns(state.workBook)
        } else {
          state.errors = ['Failed to parse workbook']
          return
        }

        const {isValid, errorMessage} = validateColumns(state.columnTitles)

        state.canStartImport = isValid
        if (errorMessage) {
          state.errors = [errorMessage]
        }
      })
    } catch (e) {
      state.errors = ['Wrong file']
    }
  }
